var _dec, _class;
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
let FlyMenuFooter = (_dec = classNames('fly-menu-footer'), _dec(_class = class FlyMenuFooter extends Component {}) || _class);
export { FlyMenuFooter as default };